const urlBase64ToUint8Array = (base64String: string) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const getVapidPublicKey = async (): Promise<string> => {
  const resp = await fetch("/api/webpush/vapid-public-key/", {
    credentials: "include",
  });
  if (!resp.ok) {
    throw new Error(`Failed to fetch VAPID public key: ${resp.status}`);
  }
  const data = await resp.json();
  return data.publicKey as string;
};

export const subscribe = async (registration: ServiceWorkerRegistration) => {
  if (Notification.permission !== "granted") return;
  if (!("PushManager" in window)) {
    console.error("PushManager not supported in this browser");
    return;
  }

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const publicKey = await getVapidPublicKey();
    const applicationServerKey = urlBase64ToUint8Array(publicKey);
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });
  }

  await fetch("/api/webpush/subscribe/", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(subscription),
  });
};
